var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthenticationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 233,
    height: 228.261,
    viewBox: "0 0 233 228.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16974 773)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16985.902 -774.91)",
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.134 1.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.468,109.245C180.459,75.546,182.8,41,172.19,24.761S129.965-19.483,55.264,29.312s-55.7,101.837-44.028,119.7C65.866,232.642,241.451,168.927,202.468,109.245Z",
    transform: "translate(-0.134 -1.91)",
    fill: "#eefffc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.634 3.588)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H5.819V11.639H0Z",
    transform: "translate(0 4.114) rotate(-45)",
    fill: "#eefffc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 23.666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H11.639V5.819H0Z",
    transform: "translate(0 8.228) rotate(-45)",
    fill: "#eefffc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.657 0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H11.639V5.819H0Z",
    transform: "translate(0 8.228) rotate(-45)",
    fill: "#eefffc"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.383 142.871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.479,44.208a8.729,8.729,0,1,1,8.729-8.729A8.74,8.74,0,0,1,35.479,44.208Zm0-11.639a2.91,2.91,0,1,0,2.91,2.91A2.914,2.914,0,0,0,35.479,32.569Z",
    transform: "translate(-6.75 -1.75)",
    fill: "#e7e7f2"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.5,
    cy: 9.5,
    rx: 116.5,
    ry: 9.5,
    transform: "translate(16974 -563.739)",
    fill: "#eefffc",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16857.092 -766.728)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.25 48.027)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.123 0.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.435,
    height: 83.696,
    rx: 6.56,
    fill: "none",
    stroke: "#2c92f7",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.821 4.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.479,58.835a1.563,1.563,0,1,1-1.563-1.563A1.563,1.563,0,0,1,201.479,58.835Z",
    transform: "translate(-198.352 -57.272)",
    fill: "#2c92f7",
    stroke: "#2c92f7",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.388 4.36)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.563,
    cy: 1.563,
    r: 1.563,
    fill: "#2c92f7",
    stroke: "#2c92f7",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.954 4.36)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.563,
    cy: 1.563,
    r: 1.563,
    fill: "#2c92f7",
    stroke: "#2c92f7",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.123 10.236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.946,69.854c0,.068-20.246.123-45.215.123s-45.22-.055-45.22-.123,20.242-.123,45.22-.123S280.946,69.786,280.946,69.854Z",
    transform: "translate(-190.511 -69.731)",
    fill: "#263238",
    stroke: "#2c92f7",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.475 18.777)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.146 2.692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.749,118.094s.045-.062.136-.182l.076-.1c.026-.039.049-.084.077-.132a2.046,2.046,0,0,0,.172-.344c.027-.068.058-.139.085-.215l.068-.248a1.765,1.765,0,0,0,.057-.276c.012-.1.039-.2.042-.3a5.765,5.765,0,0,0-.067-1.466,13.2,13.2,0,0,0-1.347-3.792,29.569,29.569,0,0,0-2.892-4.5,46.049,46.049,0,0,0-4.311-4.843,52.829,52.829,0,0,0-5.661-4.832c-1.057-.776-2.171-1.529-3.347-2.239a32.214,32.214,0,0,0-3.717-1.949,17.4,17.4,0,0,0-4.135-1.3,7.319,7.319,0,0,0-2.206-.054,4.151,4.151,0,0,0-1.066.308,2.656,2.656,0,0,0-1.443,1.616,4.132,4.132,0,0,0-.186,1.094,7.29,7.29,0,0,0,.3,2.186,17.345,17.345,0,0,0,1.758,3.963,32.31,32.31,0,0,0,2.359,3.472c.839,1.087,1.715,2.109,2.606,3.07a52.71,52.71,0,0,0,5.445,5.075,46.078,46.078,0,0,0,5.3,3.733,29.62,29.62,0,0,0,4.8,2.361,13.191,13.191,0,0,0,3.92.906,5.76,5.76,0,0,0,1.464-.1,2.95,2.95,0,0,0,.3-.077,1.7,1.7,0,0,0,.268-.088l.238-.1c.073-.036.14-.075.2-.11a2.017,2.017,0,0,0,.322-.21c.044-.033.087-.061.122-.091l.091-.087c.108-.1.165-.155.165-.155s-.052.055-.159.161l-.09.089c-.035.031-.077.06-.121.093a1.956,1.956,0,0,1-.321.215c-.064.035-.13.076-.2.113l-.239.1a1.754,1.754,0,0,1-.269.091,2.979,2.979,0,0,1-.3.079,5.729,5.729,0,0,1-1.471.108,13.143,13.143,0,0,1-3.936-.894,29.514,29.514,0,0,1-4.811-2.353,45.873,45.873,0,0,1-5.317-3.729,52.746,52.746,0,0,1-5.458-5.077c-.894-.962-1.772-1.986-2.613-3.074a32.363,32.363,0,0,1-2.368-3.48,17.44,17.44,0,0,1-1.768-3.983A7.375,7.375,0,0,1,263,94.34a4.221,4.221,0,0,1,.19-1.119,2.737,2.737,0,0,1,1.489-1.667,4.2,4.2,0,0,1,1.089-.316,7.387,7.387,0,0,1,2.231.055,17.411,17.411,0,0,1,4.156,1.3,32.326,32.326,0,0,1,3.726,1.956c1.177.712,2.293,1.468,3.351,2.246a52.649,52.649,0,0,1,5.664,4.845,45.913,45.913,0,0,1,4.31,4.857,29.518,29.518,0,0,1,2.886,4.512,13.164,13.164,0,0,1,1.337,3.808,5.739,5.739,0,0,1,.059,1.474,2.838,2.838,0,0,1-.044.306,1.782,1.782,0,0,1-.06.277l-.071.249c-.028.077-.061.148-.088.216a2.037,2.037,0,0,1-.177.344c-.028.047-.052.093-.078.131l-.078.1C292.8,118.035,292.749,118.094,292.749,118.094Z",
    transform: "translate(-262.995 -91.177)",
    fill: "#00bfa3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.398 9.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.488,109.976s-.008-.077-.02-.226l-.009-.125c-.006-.046-.02-.1-.031-.15a2.08,2.08,0,0,0-.1-.371c-.025-.068-.048-.142-.079-.217l-.114-.23a1.737,1.737,0,0,0-.141-.244,2.882,2.882,0,0,0-.171-.255,5.733,5.733,0,0,0-1.026-1.049,13.183,13.183,0,0,0-3.529-1.933,29.576,29.576,0,0,0-5.151-1.431,46.036,46.036,0,0,0-6.442-.744,52.723,52.723,0,0,0-7.441.163c-1.306.124-2.639.3-3.988.556a32.248,32.248,0,0,0-4.071,1.02,17.376,17.376,0,0,0-3.949,1.785,7.32,7.32,0,0,0-1.682,1.428,4.145,4.145,0,0,0-.59.94,2.66,2.66,0,0,0,0,2.167,4.14,4.14,0,0,0,.589.94,7.3,7.3,0,0,0,1.682,1.429,17.352,17.352,0,0,0,3.95,1.786,32.337,32.337,0,0,0,4.072,1.02c1.35.252,2.683.433,3.989.556a52.735,52.735,0,0,0,7.442.162,45.93,45.93,0,0,0,6.442-.744,29.588,29.588,0,0,0,5.151-1.43,13.2,13.2,0,0,0,3.528-1.934,5.751,5.751,0,0,0,1.026-1.049,3.008,3.008,0,0,0,.171-.255,1.755,1.755,0,0,0,.141-.244l.114-.23c.031-.075.054-.149.079-.217a2.075,2.075,0,0,0,.1-.37c.011-.054.024-.1.031-.15l.009-.126c.012-.149.02-.226.02-.226s0,.077-.011.226l-.008.126c-.006.047-.018.1-.028.151a1.983,1.983,0,0,1-.1.374c-.024.069-.047.144-.077.219l-.113.233a1.752,1.752,0,0,1-.14.247,3.039,3.039,0,0,1-.17.258,5.737,5.737,0,0,1-1.025,1.06,13.15,13.15,0,0,1-3.532,1.952,29.535,29.535,0,0,1-5.157,1.446,45.891,45.891,0,0,1-6.45.756,52.577,52.577,0,0,1-7.452-.155c-1.308-.123-2.644-.3-4-.555a32.169,32.169,0,0,1-4.083-1.021,17.4,17.4,0,0,1-3.97-1.795,7.361,7.361,0,0,1-1.7-1.446,4.212,4.212,0,0,1-.6-.961,2.743,2.743,0,0,1,0-2.236,4.24,4.24,0,0,1,.6-.961,7.4,7.4,0,0,1,1.7-1.445,17.443,17.443,0,0,1,3.97-1.794,32.35,32.35,0,0,1,4.082-1.02c1.353-.252,2.688-.431,4-.555a52.646,52.646,0,0,1,7.451-.154,45.972,45.972,0,0,1,6.45.756,29.543,29.543,0,0,1,5.158,1.446,13.151,13.151,0,0,1,3.532,1.952,5.759,5.759,0,0,1,1.026,1.06c.068.083.115.176.17.258a1.869,1.869,0,0,1,.14.246l.113.233c.03.076.053.15.077.219a2.036,2.036,0,0,1,.1.374c.01.054.022.1.028.15l.008.126C295.485,109.9,295.488,109.976,295.488,109.976Z",
    transform: "translate(-256.635 -102.863)",
    fill: "#00bfa3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.061,87.226s-.065-.041-.19-.123l-.1-.069c-.041-.023-.088-.043-.137-.068a2.037,2.037,0,0,0-.354-.147c-.07-.022-.142-.049-.22-.071L291.8,86.7a1.712,1.712,0,0,0-.279-.038,2.822,2.822,0,0,0-.306-.021,5.731,5.731,0,0,0-1.458.168,13.185,13.185,0,0,0-3.69,1.6,29.574,29.574,0,0,0-4.287,3.195,45.937,45.937,0,0,0-4.535,4.635,52.785,52.785,0,0,0-4.431,5.98c-.7,1.107-1.376,2.272-2,3.492a32.368,32.368,0,0,0-1.688,3.842,17.364,17.364,0,0,0-1.008,4.215,7.323,7.323,0,0,0,.1,2.2,4.115,4.115,0,0,0,.381,1.041,2.655,2.655,0,0,0,1.712,1.329,4.119,4.119,0,0,0,1.1.11,7.275,7.275,0,0,0,2.16-.454,17.351,17.351,0,0,0,3.832-2.027,32.215,32.215,0,0,0,3.3-2.593c1.026-.911,1.985-1.855,2.883-2.811a52.77,52.77,0,0,0,4.688-5.782,45.984,45.984,0,0,0,3.358-5.547,29.638,29.638,0,0,0,2.025-4.947,13.194,13.194,0,0,0,.634-3.973,5.754,5.754,0,0,0-.2-1.454,2.958,2.958,0,0,0-.1-.291,1.775,1.775,0,0,0-.107-.261l-.112-.231c-.041-.07-.085-.134-.124-.2a2.06,2.06,0,0,0-.231-.306c-.037-.042-.067-.083-.1-.116l-.093-.085c-.111-.1-.166-.154-.166-.154s.06.048.172.147l.095.083c.033.033.065.074.1.115a2.065,2.065,0,0,1,.236.306c.039.061.085.125.126.2l.115.232a1.786,1.786,0,0,1,.109.262,2.937,2.937,0,0,1,.1.292,5.722,5.722,0,0,1,.21,1.46,13.161,13.161,0,0,1-.621,3.988,29.53,29.53,0,0,1-2.017,4.962,45.851,45.851,0,0,1-3.354,5.56,52.612,52.612,0,0,1-4.688,5.8c-.9.958-1.858,1.9-2.887,2.819a32.419,32.419,0,0,1-3.308,2.6,17.444,17.444,0,0,1-3.851,2.038,7.375,7.375,0,0,1-2.186.459,4.222,4.222,0,0,1-1.129-.113,2.742,2.742,0,0,1-1.766-1.371,4.242,4.242,0,0,1-.39-1.065,7.372,7.372,0,0,1-.1-2.23,17.4,17.4,0,0,1,1.014-4.236,32.258,32.258,0,0,1,1.695-3.852c.629-1.223,1.306-2.389,2.01-3.5a52.6,52.6,0,0,1,4.443-5.984,45.923,45.923,0,0,1,4.549-4.634,29.513,29.513,0,0,1,4.3-3.19,13.144,13.144,0,0,1,3.707-1.6,5.737,5.737,0,0,1,1.466-.161,2.993,2.993,0,0,1,.308.023,1.728,1.728,0,0,1,.281.041l.253.053c.078.023.151.051.22.074a2.06,2.06,0,0,1,.355.152c.049.025.1.046.137.07l.1.071C293,87.181,293.061,87.226,293.061,87.226Z",
    transform: "translate(-267.99 -86.609)",
    fill: "#00bfa3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 24.492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.493,128.373a.721.721,0,1,1-1.019,0A.72.72,0,0,1,255.493,128.373Z",
    transform: "translate(-254.263 -128.162)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.45 1.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.333,90.13a.721.721,0,1,1-.721-.721A.721.721,0,0,1,324.333,90.13Z",
    transform: "translate(-322.892 -89.409)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.415 26.889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.817,132.413a.183.183,0,1,1-.183-.183A.183.183,0,0,1,263.817,132.413Z",
    transform: "translate(-263.45 -132.23)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.324 6.695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.449,98.151a.183.183,0,1,1-.183-.183A.183.183,0,0,1,270.449,98.151Z",
    transform: "translate(-270.083 -97.968)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.904 16.511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.94,114.8a.183.183,0,1,1-.183-.183A.183.183,0,0,1,318.94,114.8Z",
    transform: "translate(-318.573 -114.622)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.45 7.972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.258,100.318a.183.183,0,1,1-.183-.183A.183.183,0,0,1,323.258,100.318Z",
    transform: "translate(-322.892 -100.135)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.802 0.866)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.084,107.934h-2.265V95.606a5.262,5.262,0,0,0-10.524,0v12.327H277.03V95.606a7.527,7.527,0,1,1,15.054,0Z",
    transform: "translate(-277.03 -88.079)",
    fill: "#2c92f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 14.371)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.287,
    height: 13.016,
    rx: 2.252,
    fill: "#2c92f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.448 17.487)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.314,119.444a1.7,1.7,0,1,0-2.158,1.624V123.6h.925v-2.536A1.69,1.69,0,0,0,290.314,119.444Z",
    transform: "translate(-286.923 -117.748)",
    fill: "#07090d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.997 16.457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.366,125.7c-.047,0-.084-2.171-.084-4.848s.038-4.848.084-4.848.084,2.17.084,4.848S274.413,125.7,274.366,125.7Z",
    transform: "translate(-274.282 -116)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.703 17.012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.772,121.286c-.005.008-.08-.027-.2-.113a2.057,2.057,0,0,1-.437-.446,2.376,2.376,0,0,1,.845-3.566,2.073,2.073,0,0,1,.59-.2.536.536,0,0,1,.229-.012,5.341,5.341,0,0,0-.762.318,2.35,2.35,0,0,0-.8,3.394A5.278,5.278,0,0,0,286.772,121.286Z",
    transform: "translate(-285.658 -116.942)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.107 62.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.77,
    height: 9.329,
    rx: 4.665,
    fill: "none",
    stroke: "#2c92f7",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.77 65.648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.89,188.813l.872.473-.392.657-.881-.521.016.969h-.753l.008-.977-.881.529-.384-.657.873-.473-.873-.481.384-.656.881.529-.008-.978h.753l-.016.978.881-.529.392.656Z",
    transform: "translate(-255.495 -187.227)",
    fill: "#2c92f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.6,188.813l.872.473-.392.657-.881-.521.016.969h-.753l.008-.977-.881.529-.384-.657.873-.473-.873-.481.384-.656.881.529-.008-.978h.753l-.016.978.881-.529.392.656Z",
    transform: "translate(-259.567 -187.227)",
    fill: "#2c92f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.3,188.813l.873.473-.393.657-.881-.521.016.969h-.753l.008-.977-.881.529-.384-.657.873-.473-.873-.481.384-.656.881.529-.008-.978h.753l-.016.978.881-.529.393.656Z",
    transform: "translate(-263.639 -187.227)",
    fill: "#2c92f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.01,188.813l.873.473-.392.657-.881-.521.017.969h-.753l.008-.977-.881.529-.384-.657.873-.473-.873-.481.384-.656.881.529-.008-.978h.753l-.017.978.881-.529.392.656Z",
    transform: "translate(-267.711 -187.227)",
    fill: "#2c92f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.717,188.813l.873.473-.392.657-.881-.521.016.969h-.753l.008-.977-.881.529-.384-.657.873-.473-.873-.481.384-.656.881.529-.008-.978h.753l-.016.978.881-.529.392.656Z",
    transform: "translate(-271.784 -187.227)",
    fill: "#2c92f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.424,188.813l.873.473-.392.657-.881-.521.017.969h-.753l.008-.977-.881.529-.384-.657.873-.473-.873-.481.384-.656.881.529-.008-.978h.753l-.017.978.881-.529.392.656Z",
    transform: "translate(-275.856 -187.227)",
    fill: "#2c92f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.13,188.813l.873.473-.392.657-.881-.521.017.969h-.753l.008-.977-.881.529-.384-.657.873-.473-.873-.481.384-.656.881.529-.008-.978h.753l-.017.978.881-.529.392.656Z",
    transform: "translate(-279.928 -187.227)",
    fill: "#2c92f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.837,188.813l.873.473-.392.657-.881-.521.016.969H310.7l.008-.977-.881.529-.384-.657.873-.473-.873-.481.384-.656.881.529-.008-.978h.753l-.016.978.881-.529.392.656Z",
    transform: "translate(-284 -187.227)",
    fill: "#2c92f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.984 66)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.3,32.376,108,29.443l-8.213,2.893c-1.048.488-1.968.78-1.968,1.741v4.789a17.893,17.893,0,0,0,2.705,9.531,16.753,16.753,0,0,0,7.556,6.571c3.357-1.074,5.863-3.936,7.395-6.385a17.89,17.89,0,0,0,2.705-9.531V34.747A2.267,2.267,0,0,0,116.3,32.376Z",
    transform: "translate(-97.824 -29.443)",
    fill: "#2c92f7",
    stroke: "#2c92f7",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.343 8.367)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.22,61.63a2.3,2.3,0,1,0-2.923,2.2v3.433h1.253V63.829A2.289,2.289,0,0,0,132.22,61.63Z",
    transform: "translate(-127.627 -59.334)",
    fill: "#f1f1f1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticationIcon);
export default __webpack_public_path__ + "static/media/authentication-icon.d982432e14255f8c4395b89c805df093.svg";
export { ForwardRef as ReactComponent };